import React from 'react';
import TestimonialsSection from '../components/TestimonialsSection';

const TestimonialsPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-nitzan-light-bg via-white to-nitzan-sage/10">
      <div className="pt-20">
        <TestimonialsSection />
      </div>
    </div>
  );
};

export default TestimonialsPage;

